import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { DropdownListSettingsLanguageModel } from '@fi-shared/dropdown';
import { ContentLanguagesService } from '../utilities/fi-services/content-languages.service';
import { WidgetType } from '@fi-shared/types/widget-type';
import { WidgetPlaceHolderControlModel } from '@fi-shared/widget/widget-place-holder-control.model';
import { IWidgetSettingsModel } from '@fi-shared/widget/widget-settings.model';
import { WidgetSharedService } from '@fi-shared/widget/widget-shared.service';
import { IDropdownSelectLanguageSettingsItem } from '@fi-shared/fi-content-language-shared/fi-content-language-shared';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';

@Component({
    selector: 'fi-widget-settings',
    templateUrl: './widget-settings.component.html',
    styleUrls: ['./widget-settings.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-widget-settings' },
    standalone: false,
})
export class WidgetSettingsComponent implements OnInit {
    @Input() widgetSettings: IWidgetSettingsModel;
    @Input() widgetName: string;
    @Input() isStartPage: boolean = false;
    @Input() widgetControl: WidgetPlaceHolderControlModel;
    @Input() widgetMode: boolean;
    WidgetType = WidgetType;

    LanguageListData: DropdownListSettingsLanguageModel<IDropdownSelectLanguageSettingsItem>;
    ShowAllLanguages: boolean = false;

    constructor(
        private contentLanguagesService: ContentLanguagesService,
        private widgetSharedService: WidgetSharedService,
        private fiUserDataService: FiUserDataService,
    ) {}

    ngOnInit() {
        this.LanguageListData = this.contentLanguagesService.GetDropdownListSettingsLanguage();
    }

    isPreferredContentLanguageId(contentLanguageId: number): boolean {
        return contentLanguageId === this.fiUserDataService.getContentLanguage();
    }

    ToggleShowAllLanguages() {
        this.ShowAllLanguages = !this.ShowAllLanguages;
    }

    settingsPropertyOnChange(data?: { skipReloadData?: boolean }) {
        this.widgetSharedService.raiseWidgetSettingsChanged(this.widgetSettings, data);
    }
}
